import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { modifiersType } from 'types'

const TITLE_MODIFIERS = {
  fixMarginBottom: () => `
    margin-bottom: 0;
  `,
  fixSpacing: () => `
    margin: 0;
  `,
  paddingBottomM: ({ theme }) => `
    padding-bottom: ${theme.spacing.m};
  `,
  h3: ({ theme }) => `
    font-size: ${theme.sizes.l};
  `,
  h4: ({ theme }) => `
  font-size: ${theme.sizes.s};
`,
};

const Text = styled.h1`
  font-weight: ${props => props.theme.weight.base};
  font-size: ${props => props.theme.sizes.xl2};
  color: ${props => props.theme.colors.base};
  margin-bottom: ${props => props.theme.spacing.s};
  margin-top: 0;
  ${applyStyleModifiers(TITLE_MODIFIERS)}
`;

const Title = ({ children, as, modifiers }) => {
  const modifiersComputed = useMemo(() => {
    if (typeof modifiers === 'string') return [as, modifiers]
    return [as, ...modifiers]
  }, [as, modifiers])
  return (
    <Text modifiers={modifiersComputed}>{children}</Text>
  )
};

Title.propTypes = {
  children: PropTypes.node.isRequired,
  as: PropTypes.oneOf(['h3', 'h4', 'h1']),
  modifiers: modifiersType
};

Title.defaultProps = {
  as: 'h1',
  modifiers: []
}

export default Title;
